module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_5_neg.6e28d5a4.png";